export function useIsLoggedIn(): boolean {
  const initialState = window.__INITIAL_STATE__ || { isLoggedIn: false };
  return initialState.isLoggedIn;
}
